<div class="card-box shadow text-center h-full w-full m-auto" style="max-width: 300px">
  <h1>{{ name() }}</h1>

  @if (!letsTalk()) {
    <div class="mt-5 font-bold text-xxxl">
      {{ price() | currency:currency():'symbol':'1.0-1' }}
    </div>

    <div>
      <app-pill color="outline-gray">
        <div class="flex-row-center gap-1">
          <div>{{ currency() }}</div>
          <div>/</div>
          <div i18n>month</div>
        </div>
      </app-pill>
    </div>
  } @else {
    <div class="mt-5 font-bold text-xxxl" i18n>
      Let's talk
    </div>
  }


  @if (hideCTA()) {
    <div class="mt-5">
      <button mat-flat-button disabled i18n>
        Free
      </button>
    </div>
  } @else if (letsTalk()) {
    <div class="mt-14">
      <button (click)="letsTalkClicked.emit()" mat-flat-button class="w-full" i18n>
        Let's talk
      </button>
    </div>
  } @else {
    <div class="mt-5">
      <button (click)="ctaClicked.emit()" mat-flat-button class="w-full">
        {{ ctaText() }}
      </button>
    </div>
  }

  <div class="mt-5 font-bold text-start">
    {{ featuresTitle() }}
  </div>

  <div class="flex flex-col gap-2 mt-3">
    @for (feature of features(); track $index) {
      <div class="flex-row-center gap-2">
        <div>
          <fa-icon [icon]="faCheck" class="text-green-600" />
        </div>
        <div>{{ feature }}</div>
      </div>
    }
  </div>
</div>
